import React from 'react';
import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";

const ErrorPage = () => {
  const { t } = useTranslation();

  return (
    <Result
      status="warning"
      subTitle={t('Something went wrong, try again!!')}
      extra={
        <Button onClick={() => window.location.reload()} type="primary">
          Reload Page
        </Button>
      }
    />
  );
};

export default ErrorPage;
